/** Vertical offset shared by referenced-map label layout and rendering. */
export const REFERENCED_Y_OFFSET = 20
